import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { SERVER_URL, USER_TYPE_GUEST } from '../constants';
import moving from '../moving.png';
import {Box} from '@mui/material';

function Moved (props) {

    useEffect(() => {
        handleOpen();
    }, []);

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
        const currentDate = new Date();
        const dateString = currentDate.toISOString();
        localStorage.setItem("movingDialogLastOpened", dateString);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const handleButtonClick = () => {
        window.location.href = "https://app.qyumo.com";
    };


    return(
        <React.Fragment>
            <Dialog open={open}
            sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "500px",  // Set your width here
                  },
                },
            }}
            style={{
                zIndex: 1302,
            }}
            >
                <DialogContent sx={{ m: 0, p: 4 }}>
                    <Box sx={{ textAlign: "center" }}>
                    <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        <b>Goodbye Qonsulta. <br />Hello Qyumo!</b>
                    </Typography>
                    <img src={moving} alt="" height={150} />
                    </Box>


                    <Typography sx={{ }} >                 
                    Qonsulta has winded down to give way to Qyumo. Our app is now available at:
                    </Typography>
                    <Typography sx={{ textAlign: "center", lineHeight: 3 }} variant='h6' >
                        <b>app.qyumo.com</b>
                    </Typography>
                   
  
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default Moved;